module.exports = __webpack_public_path__ + "static/media/3.eb9f73b7.jpg";